import { render, staticRenderFns } from "./EditReportSharedModal.vue?vue&type=template&id=4725157e&"
import script from "./EditReportSharedModal.vue?vue&type=script&lang=js&"
export * from "./EditReportSharedModal.vue?vue&type=script&lang=js&"
import style0 from "./EditReportSharedModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports